import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseLayout } from '../../../interfaces/base-layout.interface';
import { ClientCvTemplateService } from '../../templates/client-cv-template.service';

@Component({
  selector: 'bst-cv-studio-pane-builtin',
  templateUrl: './studio-pane-builtin.component.html',
  styleUrls: ['./studio-pane-builtin.component.scss'],
  standalone: false,
})
export class StudioPaneBuiltinComponent {
  @Input() layout!: BaseLayout;
  @Input() clientId!: number;
  @Output() useAsBase = new EventEmitter<string>();

  constructor(private readonly service: ClientCvTemplateService) {}

  public sampleImageUrl(): string {
    return this.service.baseLayoutSampleImageUrl(this.layout.id);
  }

  public downloadBlank(): void {
    window.open(this.service.baseLayoutSamplePdfUrl(this.layout.id), '_blank');
  }

  public emitUseAsBase(): void {
    this.useAsBase.emit(this.layout.id);
  }
}
